// extracted by css-extract-rspack-plugin
export default {"actionButton":"I3yDi"};